import React, { useLayoutEffect, useRef, useState } from 'react';
import isNil from 'lodash/isNil';

interface Params {
    isOpen?: boolean;
    onOpenClick?(): void;
    onClickOutside?(event?: any): void;
}

interface Data {
    isOpen: boolean;
    maxHeight: number;
    cardRef: React.RefObject<HTMLDivElement | null>;
    onOpenClick?(): void;
    onClickOutside(event?: any): void;
}

export function useFoldingComponent({ isOpen: isOpenProp, onOpenClick, onClickOutside }: Params): Data {
    const [isOpen, setIsOpen] = useState(false);
    const [maxHeight, setMaxHeight] = useState(0);
    const cardRef = useRef<HTMLDivElement | null>(null);

    useLayoutEffect(() => {
        const card = cardRef.current;
        if (!card) {
            return;
        }

        const updateMaxHeight = () => setMaxHeight(card.offsetHeight);
        updateMaxHeight();

        const observer = new ResizeObserver(updateMaxHeight);
        observer.observe(card);

        return () => observer.disconnect();
    }, []);

    const openContent = async (): Promise<void> => {
        await onOpenClick?.();
        setIsOpen(true);
    };

    const foldingContent = async (event?: any): Promise<void> => {
        await onClickOutside?.(event);
        setIsOpen(false);
    };

    const isControlled = !isNil(isOpenProp);

    return {
        isOpen: isControlled ? (isOpenProp as boolean) : isOpen,
        maxHeight,
        cardRef,
        onOpenClick: isControlled ? onOpenClick : openContent,
        onClickOutside: isControlled ? (onClickOutside as (event?: any) => void) : foldingContent,
    };
}
